import { InjectRepository } from "@nestjs/typeorm";
import { MachinesNeedleMappingEntity } from "./entity/machine-needle-mapping.entity";
import { Injectable } from "@nestjs/common";
import { Repository } from "typeorm";

@Injectable()
export class MachinesNeedleMappingRepository extends Repository<MachinesNeedleMappingEntity> {

    constructor(@InjectRepository(MachinesNeedleMappingEntity) private machinesNeedleRepo: Repository<MachinesNeedleMappingEntity>
    ) {
        super(machinesNeedleRepo.target, machinesNeedleRepo.manager, machinesNeedleRepo.queryRunner);
    }

    async getAllMachineNeedleMappingQuery(): Promise<any> {
      return await this.createQueryBuilder('mnm')
        .leftJoin('style', 's', 'mnm.styles_id = s.id')
        .leftJoin('needle_model', 'nm', 'mnm.needle_model_id = nm.id')
        .leftJoin('needle_sizes', 'ns', 'mnm.needle_sizes_id = ns.id')
        .leftJoin('machines', 'm', 'mnm.machines_id = m.id')
        .leftJoin('point_types', 'pt', 'mnm.needle_point_type_id = pt.id')
        .select([
          's.style AS style', 'm.machine_type AS machineType',
          'mnm.styles_id AS stylesId',
          'nm.needle_model AS needleModel',
          'mnm.needle_model_id AS needleModelId',
          'ns.needle_sizes AS needleSizes',
          'mnm.machines_id AS machineId',
          'mnm.needle_sizes_id AS needleSizesId',
          'mnm.id AS id',
          'mnm.is_active AS isActive',
          'mnm.machines_id AS machinesId',
          'm.machine AS machines',
          'mnm.needle_point_type_id AS needlePointTypeId',
          'pt.point_type AS needlePointType',
        ]).orderBy("m.machine_type,m.machine,nm.needle_model,pt.point_type,ns.needle_sizes")
        .getRawMany();
    }
    
      
    

}

